<template>
  <admin-sales-summary
    :stats="stats"
    :loading="loading"
  />
</template>
<script>
import AdminSalesSummary from './AdminSalesSummary';

export default {
  name: 'AdminSalesSummaryContainer',
  components: { AdminSalesSummary },
  props: {
    dataRange: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      custom_url: null,
    };
  },
  computed: {
    stats() {
      // Parent has to retrieve this from backend
      const institutionStats = this.$store.state.institutions.salesOverview;
      if (Object.keys(institutionStats).length === 0 && institutionStats.constructor === Object) return [];
      return institutionStats;
    },
    institutionId() {
      return this.$store.state.institutions.item.pk;
    },
    loading() {
      if (!this.institutionId) {
        return true;
      }
      return this.$store.state.institutions.isLoadingSalesOverview;
    },
  },
  watch: {
    institutionId(newval) {
      if (newval) {
        this.fetchData();
      }
    },
    dataRange(newval) {
      this.fetchCustomData();
    },
    custom_url(newval) {
      if (newval) {
        this.fetchCustomData();
      }
    },
  },
  methods: {
    fetchData() {
      this.$store.dispatch('institutions/fetchSalesOverview', this.institutionId).then((response) => {
        if (response.url) {
          this.custom_url = response.url;
          this.$emit('hasCustomUrl');
        }
      });
    },
    fetchCustomData() {
      if (this.custom_url) {
        this.$store.dispatch('institutions/fetchCustomSalesOverview', {
          url: this.custom_url,
          range: this.dataRange,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.orange {
  background-color: #F8E6D8;
}
</style>
